import { ReactElement, useEffect, useRef, useState } from "react";
import * as THREE from "three";
// @ts-ignore
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
// @ts-ignore
import { RGBELoader } from "three/addons/loaders/RGBELoader.js";
import "./index.css";

let camera: any, scene: any, renderer: any, mixer: any;
const clock = new THREE.Clock();
const animationActions: any[] = [];
const waitings = new Set();
const glwh = window.innerWidth;
const glheight = window.innerHeight;

interface IProps {
  id?: number;
  coin?: number;
  addCoin: "Silver" | "Pearl" | "Gold";
  onClickNextEx: () => void;
}
let animType: any = "3d";
let loadPromis: Promise<any> | undefined = undefined;
let loadPearlPromis: Promise<any> | undefined = undefined;
let loadsilverGPromis: Promise<any> | undefined = undefined;

export function RewardLesson(props: IProps): ReactElement {
  const cnt = useRef<HTMLDivElement>(null);
  const [hide_button, set_hide_button] = useState<boolean>(true);
  let monetType = "серебряных монет";
  let video_modificator = "";
  switch (props.addCoin) {
    case "Pearl":
      monetType = "жемчуг";
      video_modificator = "_video_gold";
      break;
    case "Gold":
      monetType = "золотую монету";
      video_modificator = "_video_gold";
      break;
  }
  useEffect(() => {
    if (cnt.current) {
      switch (props.addCoin) {
        case "Pearl":
          startVideoPearl(cnt.current, () => set_hide_button(false));
          break;
        case "Gold":
          startSilverGVideo(cnt.current, () => set_hide_button(false));
          break;
        default:
          init(cnt.current, () => set_hide_button(false));
      }
    }
  }, [props.addCoin]);
  const clck = () => {
    continueAnim();
    set_hide_button(true);
    setTimeout(() => {
      props.onClickNextEx();
    }, 3000);
  };
  return (
    <>
      <div className="rewardConteinerFlexConteiner">
        <div className="rewardConteiner">
          <div className="rewardConteiner-Mess">
            <p className="rewardConteiner-cauntCoinText">
              Вы получили {props.coin}
            </p>
            <p className="rewardConteiner-cauntCoinText">{monetType}</p>
          </div>
          <div
            className="lessonPageReward-button"
            onClick={clck}
            style={{ visibility: hide_button ? "hidden" : undefined }}
          >
            Спасибо!
          </div>
        </div>
      </div>
      <div className={"glanimation" + video_modificator} ref={cnt} />
    </>
  );
}

async function init(container: any, onPause: () => void) {
  if (!loadPromis) load3dAnimation();
  camera = new THREE.PerspectiveCamera(45, glwh / glheight, 0.25, 20);
  camera.position.set(-1.8, 0.6, 2.7);

  scene = new THREE.Scene();
  loadPromis?.then((r) => {
    start(r, onPause);
  });
  renderer = new THREE.WebGLRenderer({
    antialias: true,
    preserveDrawingBuffer: true,
    alpha: true,
  });
  animType = "3d";
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(glwh, glheight);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1;
  renderer.setAnimationLoop(render);
  container.appendChild(renderer.domElement);
}

function start_animation(anim_action: any) {
  anim_action.reset();
  waitings.add(anim_action);
  anim_action.play();
}

function render() {
  const delta = clock.getDelta();

  if (mixer) mixer.update(delta);
  renderer.render(scene, camera);
}

export function load3dAnimation() {
  if (loadPromis) return;
  loadPromis = new Promise((r) => {
    new RGBELoader()
      .setPath("/")
      .load("royal_esplanade_1k.hdr", function (texture: any) {
        const loader = new GLTFLoader().setPath("/");
        loader.load("serebroCA1.gltf", async function (gltf: any) {
          texture.mapping = THREE.EquirectangularReflectionMapping;
          loadPearlVideo().then(() => loadSilverGVideo());
          r({ gltf, texture });
        });
      });
  });
}

export function loadPearlVideo() {
  if (loadPearlPromis) return loadPearlPromis;
  loadPearlPromis = new Promise((r) => {
    fetch("/goldp.webm")
      .then((res) => res.blob())
      .then((blob) => r(URL.createObjectURL(blob)));
  });
  return loadPearlPromis;
}

export function loadSilverGVideo() {
  if (loadsilverGPromis) return loadsilverGPromis;
  loadsilverGPromis = new Promise((r) => {
    fetch("/silver_gold.webm")
      .then((res) => res.blob())
      .then((blob) => r(URL.createObjectURL(blob)));
  });
  return loadsilverGPromis;
}

function startVideoPearl(container: any, onPause: () => void) {
  loadPearlVideo().then((r) => {
    const video = document.createElement("video");
    video.setAttributeNS(null, 'width', "1125");
    video.setAttributeNS(null, 'height', "2436");
    video.src = r;
    const can = document.createElement("canvas");
    can.setAttributeNS(null, 'width', "1125");
    can.setAttributeNS(null, 'height', "2436");
    //@ts-ignore
    container.querySelectorAll("*").forEach((n) => n.remove());
    container.append(can);

    container.append(video);
    const proc = new Processor(video, can);
    proc.doLoad();
    video.play();
    animType = video;
    setTimeout(() => {
      video.pause();
      onPause();
    }, 4500);
  });
}

function startSilverGVideo(container: HTMLDivElement, onPause: () => void) {
  loadSilverGVideo().then((r) => {
    const video = document.createElement("video");
    video.setAttributeNS(null, 'width', "1125");
    video.setAttributeNS(null, 'height', "2436");
    video.src = r;
    const can = document.createElement("canvas");
    can.setAttributeNS(null, 'width', "1125");
    can.setAttributeNS(null, 'height', "2436");
    //@ts-ignore
    container.querySelectorAll("*").forEach((n) => n.remove());
    container.append(can);

    container.append(video);
    const proc = new Processor(video, can);
    proc.doLoad();
    video.play();
    animType = video;
    setTimeout(() => {
      video.pause();
      onPause();
    }, 4500);
  });
}

class Processor {
  video: HTMLVideoElement;
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  constructor(video: HTMLVideoElement, canvas: HTMLCanvasElement) {
    this.video = video;
    this.canvas = canvas;
    this.ctx = this.canvas.getContext("2d") as CanvasRenderingContext2D;
    this.width = +this.video.width;
    this.height = +this.video.height;
  }
  timerCallback() {
    if (this.video.paused || this.video.ended) {
      return;
    }
    this.computeFrame();
    let self = this;
    setTimeout(function () {
      self.timerCallback();
    }, 0);
  }

  doLoad() {
    this.video.addEventListener(
      "play",
      () => {
        this.width = +this.video.width;
        this.height = +this.video.height;
        this.timerCallback();
      },
      false
    );
  }

  computeFrame() {
    // this.ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
    // this.ctx.clearRect(0, 0, this.width, this.height);
    this.ctx.drawImage(this.video, 0, 0, this.width, this.height);
    // let frame = this.ctx.getImageData(0, 0, this.width, this.height);
    // let l = frame.data.length;

    // for (let i = 0; i < l; i++) {
    //   let r = frame.data[i * 4 + 0];
    //   let g = frame.data[i * 4 + 1];
    //   let b = frame.data[i * 4 + 2];
    //   if (g > 100 && r > 100 && b < 43) frame.data[i * 4 + 3] = 0;
    // }
    return;
  }
}

// document.addEventListener("DOMContentLoaded", () => {
// processor.doLoad();
// });

async function start({ gltf, texture }: any, onPause: () => void) {
  scene.environment = texture;
  const model = gltf.scene;
  await renderer.compileAsync(model, camera, scene);
  mixer = new THREE.AnimationMixer(gltf.scene);

  for (const anim of gltf.animations) {
    const action = mixer.clipAction(anim);
    action.setLoop(THREE.LoopOnce);
    animationActions.push(action);
  }
  animationActions.forEach(start_animation);
  camera = gltf.cameras[0];
  camera.position.x = -17;
  camera.position.y = 3.5;
  //@ts-ignore
  window._camera = camera;

  setTimeout(() => {
    animationActions.forEach((a) => (a.paused = true));
    onPause();
  }, 5650);
  camera.aspect = glwh / glheight;
  camera.updateProjectionMatrix();
  scene.add(model);
}

function continueAnim() {
  if (animType === "3d") animationActions.forEach((a) => (a.paused = false));
  else animType.play();
}
